<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12">
        <b class="subtitle-1 ml-1 mr-3">{{ label }}</b>
        <slot name="new_action" v-if="!readOnly"></slot>
        <!-- {{value}} -->
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col cols="12" sm="12" md="6">
        <v-card outlined>
          <v-text-field solo ref="search" v-model="search" @input="$emit('search-change', search)" full-width
            hide-details label="Filtrar" single-line clearable :loading="loadingItems" autocomplete="off"
            :disabled="readOnly">
            <template v-slot:append>
              <v-btn depressed @click="addAllItens"
                :disabled="(maxLimit && items.length > maxLimit) ? readOnly : false">
                Adicionar Todos
                <v-icon right>mdi-arrow-right-drop-circle</v-icon>
              </v-btn>
            </template>
          </v-text-field>

          <!--<v-list 
            class="overflow-y-auto pt-0" 
            style="height: 300px" 
            v-if="items && items.length > 0"
          >
            <template v-for="(item, i) in items">
              <template
                v-if="!value.includes(item.id) && itemIsInSearch(item[`${itemText}`], item[`${itemSubText}`], item[`${itemSecondSubText}`], search)"
              >
                <v-divider
                  :key="'dividerItems' + i"
                ></v-divider>

                <v-list-item
                  :key="i"
                  :disabled="readOnly || loading || (maxLimit && selections.length >= maxLimit)"
                  @click="value.push(item.id); selections.push(item); gotSelected = true"
                  :two-line="itemSubText && !itemSubText ? true : false"
                  :three-line="itemSubText && itemSecondSubText ? true : false"
                  class="pr-0 pr-lg-2"
                > 

                  <v-tooltip top color="#7e7e7e" open-delay="500">
                    <template v-slot:activator="{ on }">           
                      <v-list-item-content v-on="on">
                        <v-list-item-title
                          class="text-subtitle-2 text-lg-subtitle-1"
                          v-text="item[`${itemText}`]"
                        ></v-list-item-title>
                        <v-list-item-subtitle
                          class="text-truncate text-caption text-lg-body-2"
                          v-if="itemSubText && item[`${itemSubText}`]"
                        >
                          {{item[`${itemSubText}`]}} 
                        </v-list-item-subtitle>
                        <v-list-item-subtitle
                          class="text-truncate text-caption text-lg-body-2"
                          v-if="itemSecondSubText && item[`${itemSecondSubText}`]"
                        >
                          {{ (itemSecondSubText && item[itemSecondSubText]) ? item[itemSecondSubText] : '' }}
                        </v-list-item-subtitle>
                      </v-list-item-content>

                      </template>
                    <span>
                      <div><b>{{item[`${itemText}`]}}</b></div>
                      <div v-if="itemSubText && item[`${itemSubText}`]"> {{item[`${itemSubText}`]}} </div>
                      <div v-if="itemSecondSubText && item[`${itemSecondSubText}`]"> {{ (itemSecondSubText && item[itemSecondSubText]) ? item[itemSecondSubText] : '' }} </div>
                    </span>
                  </v-tooltip>


                  <v-list-item-action class="ma-0">
                    <v-btn icon>
                      <v-icon color="grey lighten-1"
                        >mdi-arrow-right-drop-circle</v-icon
                      >
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>

              </template>
            </template>

          </v-list> -->
          <v-virtual-scroll ref="myVirtualScroller" :items="itemsFiltered" item-height="88" height="300" v-if="items && items.length > 0"
            :key="scrollKey" >
            <template v-slot:default="{ item, i }">
              <!--<template
                v-if="!value.includes(item.id) && itemIsInSearch(item[`${itemText}`], item[`${itemSubText}`], item[`${itemSecondSubText}`], search)"
              >-->
              <v-divider :key="'dividerItems' + i"></v-divider>

              <v-list-item :key="i" :disabled="readOnly || loading || (maxLimit && selections.length >= maxLimit)"
                @click="value.push(item.id); selections.push(item); gotSelected = true; updateList(search);"
                :two-line="itemSubText && !itemSubText ? true : false"
                :three-line="itemSubText && itemSecondSubText ? true : false" class="pr-0 pr-lg-2">

                <v-tooltip top color="#7e7e7e" open-delay="500">
                  <template v-slot:activator="{ on }">
                    <v-list-item-content v-on="on">
                      <v-list-item-title class="text-subtitle-2 text-lg-subtitle-1"
                        v-text="item[`${itemText}`]"></v-list-item-title>
                      <v-list-item-subtitle class="text-truncate text-caption text-lg-body-2"
                        v-if="itemSubText && item[`${itemSubText}`]">
                        {{ item[`${itemSubText}`] }}
                      </v-list-item-subtitle>
                      <v-list-item-subtitle class="text-truncate text-caption text-lg-body-2"
                        v-if="itemSecondSubText && item[`${itemSecondSubText}`]">
                        {{ (itemSecondSubText && item[itemSecondSubText]) ? item[itemSecondSubText] : '' }}
                      </v-list-item-subtitle>
                    </v-list-item-content>

                  </template>
                  <span>
                    <div><b>{{ item[`${itemText}`] }}</b></div>
                    <div v-if="itemSubText && item[`${itemSubText}`]"> {{ item[`${itemSubText}`] }} </div>
                    <div v-if="itemSecondSubText && item[`${itemSecondSubText}`]"> {{ (itemSecondSubText &&
                      item[itemSecondSubText]) ?
                      item[itemSecondSubText] : '' }} </div>
                  </span>
                </v-tooltip>


                <v-list-item-action class="ma-0">
                  <v-btn icon>
                    <v-icon color="grey lighten-1">mdi-arrow-right-drop-circle</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>

              <!--</template>-->
            </template>

          </v-virtual-scroll>

        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <p v-if="showRequiredError" class="v-messages__message red--text mb-0">
          Pelo menos 1 item deve ser selecionado
        </p>
        <v-card outlined v-bind:class="{ 'multiSelectError': showRequiredError }">

          <v-subheader v-bind:class="{ 'red--text': showRequiredError }" class="ml-0 py-3 mt-2"
            style="border-bottom: 1px solid #e0e0e0;">
            <v-btn depressed @click="removeAllItens" :disabled="readOnly">
              <v-icon left>mdi-arrow-left-drop-circle</v-icon>
              Remover Todos
            </v-btn>
            <v-spacer></v-spacer>
            <b>Itens Selecionados</b>
          </v-subheader>

          <v-list class="overflow-y-auto pt-0" style="height: 300px" v-if="items && items.length > 0">
            <template v-for="(selection, i) in selections">
              <v-divider :key="'dividerSelection' + i"></v-divider>

              <v-list-item :key="i" :disabled="loading || readOnly" @click="removeSelectedItem(selection)"
                :two-line="itemSubText && !itemSubText ? true : false"
                :three-line="itemSubText && itemSecondSubText ? true : false" class="pl-0 pl-lg-2">
                <v-list-item-action class="ma-0">
                  <v-btn icon>
                    <v-icon color="grey lighten-1">mdi-arrow-left-drop-circle</v-icon>
                  </v-btn>
                </v-list-item-action>

                <v-tooltip top color="#7e7e7e" open-delay="500">
                  <template v-slot:activator="{ on }">
                    <v-list-item-content v-on="on">
                      <v-list-item-title class="text-subtitle-2 text-lg-subtitle-1"
                        v-text="selection[`${itemText}`]"></v-list-item-title>
                      <!-- <v-list-item-subtitle
                        v-if="itemSubText && selection[`${itemSubText}`]"
                        v-text="selection[`${itemSubText}`]"
                      ></v-list-item-subtitle> -->
                      <v-list-item-subtitle class="text-truncate text-caption text-lg-body-2"
                        v-if="itemSubText && selection[`${itemSubText}`]">
                        {{ selection[`${itemSubText}`] }}
                      </v-list-item-subtitle>
                      <v-list-item-subtitle class="text-truncate text-caption text-lg-body-2"
                        v-if="itemSecondSubText && selection[`${itemSecondSubText}`]">
                        {{ (itemSecondSubText && selection[itemSecondSubText]) ? selection[itemSecondSubText] : '' }}
                      </v-list-item-subtitle>

                    </v-list-item-content>
                  </template>
                  <span>
                    <div><b>{{ selection[`${itemText}`] }}</b></div>
                    <div v-if="itemSubText && selection[`${itemSubText}`]"> {{ selection[`${itemSubText}`] }} </div>
                    <div v-if="itemSecondSubText && selection[`${itemSecondSubText}`]"> {{ (itemSecondSubText &&
                      selection[itemSecondSubText]) ? selection[itemSecondSubText] : '' }} </div>
                  </span>
                </v-tooltip>


              </v-list-item>
            </template>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      search: "",
      gotSelected: false,
      selections: [],
      scrollKey: 0,
      itemsFiltered: [],
      scrollPos: 0,
      // selected: this.value
    };
  },
  props: {
    multiSelectKey: {
      type: Number,
      default: 0,
    },
    value: Array,
    label: String,
    items: {
      type: Array,
      default: () => []
    },
    itemText: {
      type: String,
      default: "name"
    },
    itemSubText: {
      type: String,
    },
    itemSecondSubText: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false
    },
    loadingItems: {
      type: Boolean,
      default: false
    },
    enableDefaultSearch: {
      type: Boolean,
      default: true
    },
    maxLimit: {
      type: Number,
      default: null
    },
    readOnly: {
      type: Boolean,
      default: false
    },
  },
  mounted() {
    this.updateSelections();
  },
  watch: {
    items: function () {
      // console.log("Alterou items", this.items)
      // this.selections = [];
      // console.log(this.$refs);
      // console.log(this.$refs.search);
      // console.log(this.$refs.myVirtualScroller);
      // var scroll = this.$refs.myVirtualScroller.$el;
      // scroll.scrollTop = 88 * 10;
      this.updateSelections();
      this.updateList(this.search);
    },
    value: function () {
      // console.log("Alterou value", this.value)
      this.selections = [];
      this.updateSelections();
    },
    "search": function (search) {
      // console.log("filtro", search);
      this.updateList(search);
    },
  },
  created() {
    this.updateList("");
  },
  methods: {
    updateList: function (search) {
      // console.log("updateList");
      var self = this;
      this.itemsFiltered = this.items.filter(item => {
        return !self.value.includes(item.id) && self.itemIsInSearch(item.name, item.additionalInfo, item.secondAdditionalInfo, search);
      });
      this.scrollKey += 1;
    },
    updateSelections: function () {
      for (const selection of this.value) {
        // console.log(selection);
        var selectedItem = this.items.find(item => {
          return item.id === selection;
        });

        if (selectedItem) {
          var isSelected = this.selections.find(item => {
            return item.id === selectedItem.id;
          })
          if (!isSelected) {
            this.selections.push(selectedItem);
          }
        }
      }
      // console.log("selected");
      // var scrollPos = null;
      var scroll;
      if(this.$refs.myVirtualScroller){
        // console.log("scroll", this.$refs.myVirtualScroller);
        scroll = this.$refs.myVirtualScroller.$el;
        // scroll.scrollTop = 88 * 5;
        this.scrollPos = scroll.scrollTop;
        // console.log(scroll.scrollTop);
      }
      this.scrollKey += 1;
      if(scroll){
        this.$nextTick(() => {
          // this.msg = 'Three';
          // console.log("atualizando", this.scrollPos);
          // console.log(this.$refs.myVirtualScroller.$el.scrollTop);
          this.$refs.myVirtualScroller.$el.scrollTop = this.scrollPos;
          // console.log(this.$refs.myVirtualScroller.$el.scrollTop);
        });
      }


    },
    removeSelectedItem: function (item) {
      this.value.splice(this.value.indexOf(item.id), 1);
      var removeItem = this.selections.find(selectionItem => {
        return selectionItem.id === item.id;
      });
      this.selections.splice(this.selections.indexOf(removeItem), 1);
      this.updateList(this.search);
      
    },
    isValid: function () {
      // console.log(this.required, this.selections.length < 1);
      if (this.required && this.selections.length < 1) {
        this.gotSelected = true;
        return false;
      }
      return true;
    },
    addAllItens: function () {
      // console.log("adicionar todos");
      if (this.items && this.items.length > 0) {
        for (let item in this.items) {
          // console.log(this.items, item, this.itemText, this.items[item], this.items[item][this.itemText])
          if (!this.value.includes(this.items[item].id) && this.itemIsInSearch(this.items[item][this.itemText], this.items[item][this.itemSubText], this.items[item][this.itemSecondSubText], this.search)) {
            this.value.push(this.items[item].id);
            this.selections.push(this.items[item]);
          }
        }
      }

      this.updateList(this.search);
    },
    removeAllItens: function () {
      // console.log("remover todos");
      this.value.splice(0, this.value.length);
      this.selections.splice(0, this.selections.length);
      this.updateList(this.search);
    },
    // :two-line="itemSubText && !itemSubText ? true : false"
    // :three-line="itemSubText && itemSecondSubText ? true : false"
    itemIsInSearch: function (string, stringSubText, stringSecondSubText, search) {
      if (this.enableDefaultSearch) {
        if (string == null || string == undefined) {
          string = "";
        }
        if (search == null || search == undefined) {
          search = "";
        }
        let resultingString = string;
        if (stringSubText) {
          resultingString = resultingString + " " + stringSubText
        }
        if (stringSecondSubText) {
          resultingString = resultingString + " " + stringSecondSubText
        }
        // console.log(stringSubText, stringSecondSubText, resultingString);
        if (stringSubText) {

        } else {
          stringSubText = "";
        }

        if (stringSecondSubText) {

        } else {
          stringSecondSubText = "";
        }

        var normalized = string.toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "");
        var normalizedSub1 = stringSubText.toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "");
        var normalizedSub2 = stringSecondSubText.toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "");

        var queryNormalized = search.toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "");
        var regex = new RegExp(queryNormalized.replaceAll(' ', '.*'));
        // console.log(normalized, normalizedSub1, normalizedSub2, regex, queryNormalized);
        // console.log(normalized, queryNormalized, regex);
        return regex.test(normalized) || regex.test(normalizedSub1) || regex.test(normalizedSub2);


        // return resultingString.toLowerCase().includes(search.toLowerCase());
      }
      else {
        return true;
      }
    }
  },
  computed: {
    allSelected() {
      return this.value.length === this.items.length;
    },
    // categories() {
    //   if (!this.search) return this.items;
    //   if (this.items.length == 0) return [];

    //   console.log("ta no categories")  
    //   const search = this.search.toLowerCase();

    //   var filteredItems = [];
    //   filteredItems = this.items.filter(item => {
    //     const text = item[this.itemText].toLowerCase();
    //     return text.indexOf(search) > -1;
    //   });

    //   return filteredItems;
    // },
    // selections() {
    //   const selections = [];
    //   console.log("ta no selections")
    //   for (const selection of this.value) {
    //     console.log(selection);
    //     var selectedItem = this.items.find(item => {
    //       return item.id === selection;
    //     });
    //     selections.push(selectedItem);
    //   }

    //   return selections;
    // },
    showRequiredError: function () {
      return (this.required && this.selections.length < 1 && this.gotSelected);
    }
  }
};

//https://github.com/vuetifyjs/vuetify/issues/3464  - > registra o componente no form, chama validacoes 
</script>

<style scoped>
.multiSelectError {
  border: 1px solid red !important;
}

::v-deep .v-tooltip__content {
  /* font-size: 50px !important; */
  opacity: 1 !important;
  /* display: block !important; */
}
</style>
